const defaultParams = {
    PAGE: 1,
    LIMIT: 100,
    MAX_LIMIT: 1000,
}

export const FORMAT_DATE = 'YYYY-MM-DD'

export default defaultParams